import React from 'react';
import { Tooltip } from 'antd';
import './OrderDashboard.css';

const StatusCard = ({
  category,
  subLabel,
  count = 0,
  unit = '件',
  theme = 'blue',
  icon,
  onClick
}) => {
  return (
    <div className={`status-card-theme-wrapper theme-${theme}`} style={{ height: '100%' }}>
      <div 
        className="status-card-wrapper" 
        onClick={onClick}
        style={{ cursor: 'pointer' }}
        role="button"
        tabIndex={0}
      >
        <div className="status-card-header">
          {icon && <span style={{ marginRight: 6 }}>{icon}</span>}
          {category}
        </div>
        <div className="status-card-body">
          <div className="status-card-sublabel">{subLabel}</div>
          <Tooltip title={`${category} - ${subLabel}: ${count}${unit}を表示`}>
            <div className="status-count-button">
              <span className="status-count-number">{count}</span>
              <span className="status-count-unit">{unit}</span>
            </div>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default StatusCard;
